import { render, staticRenderFns } from "./Retratar2.vue?vue&type=template&id=27ae31e3&scoped=true&"
import script from "./Retratar2.vue?vue&type=script&lang=js&"
export * from "./Retratar2.vue?vue&type=script&lang=js&"
import style0 from "./Retratar2.vue?vue&type=style&index=0&id=27ae31e3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ae31e3",
  null
  
)

export default component.exports